/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */

import React, { useState } from "react";
import sass from "../../index.module.sass";
import ModalPortal from "components-new/ModalPortal";
import AcceptRemove from "../../AcceptRemove";
import { useModalStepTwoDotTwo } from "../../index";
import { Button } from "components/shared";
import TextArea from "components-new/Textarea";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import { $api } from "libs/axios";
import Snackbar from "components-new/Snackbar";
import InputTemp from "components-new/InputTemp";
import {IData} from "../OperatingSystem";
import {CommonHeader, CommonRow} from "../../CommonHeader";

export interface IRow {
	id: number;
	name: string | null;
	type?: any | null;
	code?: any | null;
	provider: string | null;
	unit?: any | null;
	quantity?: any | null;
	unitWeight?: any | null;
	comment?: any | null;
	segment: string;
	objectInfluence: string;
}

// export interface IData {
// 	id: number;
// 	name: string;
// 	rows: IRow[];
// }

interface IProps {
	data: IData[];
	deleteRow: (data: IData[]) => void;
	options: { id: number; name: string }[];
	objects: {id:number,name:string}[]
	tab: number;
	activeTab: number;
	close: boolean;
	direction: string;
}
const ManagementSoftware: React.FC<IProps> = ({ data = [],objects,  deleteRow, activeTab, tab, direction, close }) => {
	/**
	 * инициальное состояние для модалки редактирования
	 * show - показывает или нет модалку
	 * data - данные для редактирования
	 */
	const initialModalEdit = {
		show: false,
		data: {} as IData,
	};

	const [selectedInfluence, setSelectedInfluence] = useState<{ id: number; name: string } | null>(null);

	/**
	 * стэйт для редактирования строки
	 * show - для модалки
	 * data - для строки
	 */
	const [edit, setEdit] = useState<{ show: boolean; data: IData }>(initialModalEdit);


	/**
	 * включение режима редактирования
	 * установка данных строки для редактирования
	 */
	function selectRow(row: IData) {
		setEdit({
			show: true,
			data: row,
		});
	}

	/**
	 * выключение режима редактирования
	 */
	function closeEditModal() {
		setEdit(initialModalEdit);
	}

	/**
	 * прослушиватель события ввода пользователем
	 */
	function onChange(e: React.ChangeEvent<HTMLTextAreaElement | HTMLSelectElement | HTMLInputElement>) {
		const name = e.target.name as keyof IRow;
		let value = e.target.value as IRow[keyof IRow];
		setEdit((prevState) => ({
			...prevState,
			data: {
				...prevState.data,
				[name]: value,
			},
		}));
	}

	/**
	 * применить изменения
	 * ищется индекс элемента в массиве, если найдет, удаляет старый элемент, вставляет новый на его место
	 */
	function applyRow() {
		const { id, ...rest } = edit.data;
		let newData: any;
		$api.put(`/object/tool/${id}`, { ...rest }).then((r) => {
			const response = r.data;
			newData = [...data].map((_) => (_.id === response.id ? { ...response } : { ..._ }));
			deleteRow(newData);
			closeEditModal();
			Snackbar({ factor: "light", type: "success", title: "Успешно сохранено", position: "top-center" });
		});
	}

	/**
	 * модалка подтверждения удаления строки таблицы
	 */
	const { submit, abort, modal, openModal } = useModalStepTwoDotTwo<number>(removeItem);

	function removeItem(id: number) {
		$api.delete("/object/tool/" + id).then(() => {
			console.log(data);
			const newData = [...data].filter((row) => row.id !== id);
			deleteRow(newData);
			Snackbar({ factor: "light", type: "success", title: "Успешно удалено", position: "top-center" });
		});
	}

	// const renderTable = useMemo(() => {
	// 	const arr: { type: string; rows: IDataWithType[] }[] = [];
	// 	options.forEach((type) => {
	// 		arr.push({ type: type.name, rows: data.filter((_) => _.segment === type.name) });
	// 	});
	// 	if (arr.length) {
	// 		return arr.map((parent, index) =>
	// 			parent.rows.length ? (
	// 				<React.Fragment key={index}>
	// 					<CommonRow select={selectRow} openModal={openModal} table={parent} />
	// 				</React.Fragment>
	// 			) : (
	// 				[]
	// 			),
	// 		);
	// 	}
	// 	return arr;
	// 	//eslint-disable-next-line
	// }, [data, options]);

	// const changeNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
	// 	let value;
	// 	value = e.target.value.replace(/[^0-9.,]/g, "").replace(/,/g, ".");
	// 	if (/^\./.test(value)) {
	// 		value = 0 + value;
	// 	}
	// 	e.target.value = value;
	// 	onChange(e);
	// };
	// const keyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
	// 	if (
	// 		(e.key === "." || e.key === ",") &&
	// 		(e.currentTarget.value.indexOf(".") !== -1 || e.currentTarget.value.indexOf(",") !== -1)
	// 	) {
	// 		e.preventDefault();
	// 	}
	// };

	function onChangeInfluence(selected: any) {
		setEdit((prevState) => ({
			...prevState,
			data: {
				...prevState.data,
				objectInfluence: selected.name,
			},
		}));
		setSelectedInfluence(selected);
	}


	return (
		<>
			{modal.active && (
				<ModalPortal title={"Удалить строку"} handleClose={abort} outSide={false}>
					<AcceptRemove submit={submit} abort={abort} />
				</ModalPortal>
			)}
			{edit.show && (
				<ModalPortal title={"Редактирование строки"} handleClose={closeEditModal} outSide={false}>
					<div className={sass.edit}>
						<div className={sass.form}>
							{/*<TextArea label={'Позиция'} name={'name'} value={edit.data.name as string || ''}  onChange={onChange}/>*/}
							<TextArea
								maxLength={150}
								label={"Наименование и тип технического средства (маркировка)"}
								name={"name"}
								value={(edit.data.name as string) || ""}
								onChange={onChange}
							/>
							<TextArea
								maxLength={150}
								label={"Заводской номер"}
								name={"type"}
								value={(edit.data.certificate as string) || ""}
								onChange={onChange}
							/>
							<TextArea
								maxLength={150}
								label={"Сведения о сертификате"}
								name={"code"}
								value={(edit.data.objectInfluence as string) || ""}
								onChange={onChange}
							/>
							{/*<TextArea*/}
							{/*	maxLength={150}*/}
							{/*	label={"Поставщик"}*/}
							{/*	name={"provider"}*/}
							{/*	value={(edit.data.provider as string) || ""}*/}
							{/*	onChange={onChange}*/}
							{/*/>*/}
							{/*<TextArea*/}
							{/*	maxLength={150}*/}
							{/*	label={"Единица измерения"}*/}
							{/*	name={"unit"}*/}
							{/*	value={(edit.data.unit as string) || ""}*/}
							{/*	onChange={onChange}*/}
							{/*/>*/}
							{/*<InputTemp*/}
							{/*	label={"Количество"}*/}
							{/*	name={"quantity"}*/}
							{/*	value={(edit.data.quantity as string) || ""}*/}
							{/*	onKeyDown={keyDown}*/}
							{/*	onChange={changeNumber}*/}
							{/*/>*/}
							{/*<InputTemp*/}
							{/*	label={"Масса единицы, кг"}*/}
							{/*	name={"unitWeight"}*/}
							{/*	value={(edit.data.unitWeight as string) || ""}*/}
							{/*	onKeyDown={keyDown}*/}
							{/*	onChange={changeNumber}*/}
							{/*/>*/}
							{/*<TextArea*/}
							{/*	maxLength={150}*/}
							{/*	label={"Примечание"}*/}
							{/*	name={"comment"}*/}
							{/*	value={(edit.data.comment as string) || ""}*/}
							{/*	onChange={onChange}*/}
							{/*/>*/}
							<InputTemp
								label={"Объект воздействия"}
								onSelect={(selected) => onChangeInfluence(selected)}
								readOnly={true}
								placeholder={"Не выбрано"}
								// name={"table"}
								value={(edit.data.objectInfluence as string) || ""}
								type={"select"}
								// options={influenceObjects}
								options={objects}
								currentValue={selectedInfluence || undefined}
								field={"name"}
							/>
						</div>
						<div className={sass.endBtn}>
							<Button variant={BUTTON_VARIANTS.OUTLINED} full={true} onClick={closeEditModal}>
								Отменить
							</Button>
							<Button color={BUTTON_COLORS.PRIMARY} full={true} onClick={applyRow}>
								Сохранить
							</Button>
						</div>
					</div>
				</ModalPortal>
			)}
			<div className={tab === activeTab && !close ? sass[`${direction}_enter`] : sass[`${direction}_out`]}>
				<CommonHeader/>
				{/*<div className={cn(sass.first, sass.tableMS)}>*/}
				{/*	<table cellSpacing="0">*/}
				{/*		<thead>*/}
				{/*			<tr>*/}
				{/*				<th>№</th>*/}
				{/*				<th>Наименование и тип технического средства (маркировка)</th>*/}
				{/*				<th>Сведения о сертификате</th>*/}
				{/*				<th>Место и дата упаковки</th>*/}
				{/*				/!*<th>Поставщик</th>*!/*/}
				{/*				/!*<th>Единица измерения</th>*!/*/}
				{/*				/!*<th>Количество</th>*!/*/}
				{/*				/!*<th>Масса единицы, кг</th>*!/*/}
				{/*				/!*<th>Примечание</th>*!/*/}
				{/*				/!*<th></th>*!/*/}
				{/*			</tr>*/}
				{/*		</thead>*/}
				{/*	</table>*/}
				{/*</div>*/}
				{/*<section data-comment-false={true} className={cn(sass.page__item, sass.page__item_active)}>*/}
					{/*<div onClick={changeActiveAccept} className={sass.caption}>*/}
					{/*    <span>Програмное обеспечение по ведению данных</span>*/}
					{/*    <TabCloseIcon className={sass.svg}/>*/}
					{/*</div>*/}
					<CommonRow data={data} select={selectRow} remove={(e,row) => {
						e.stopPropagation();
						openModal(row.id);
					}}/>
					{/*<div className={sass.table}>{renderTable as ReactNode}</div>*/}
				{/*</section>*/}
			</div>
		</>
	);
};

// /**
//  * Компонент создан для того чтобы можно было управлять состояниям открытости вкладки,
//  * чтобы у каждого раздела был свой стэйт
//  */
// const Row: React.FC<{ selectRow: Function; openModal: Function; table: any }> = ({ selectRow, openModal, table }) => {
// 	const [active, setActive] = useState(true);
// 	return (
// 		<>
// 		{/*<div className={cn(sass.colspan, sass[`colspan_${active}`])}>*/}
// 		{/*	<div className={sass.subtable} onClick={() => setActive((prevState) => !prevState)}>*/}
// 		{/*		{table.type}*/}
// 		{/*		<TabCloseIcon width={9.6} />*/}
// 		{/*	</div>*/}
// 			{!!table.rows.length && (
// 				<table>
// 					<tbody>
// 						{table.rows.map((row: any, index: number) => (
// 							<tr key={row.id} onClick={() => selectRow(row)}>
// 								<td>{index + 1}</td>
// 								<td>{row.name || "—"}</td>
// 								<td>{row.type || "—"}</td>
// 								<td>{row.code || "—"}
// 									<RemoveRow
// 										onClick={(e) => {
// 											e.stopPropagation();
// 											openModal(row.id);
// 										}}
// 										width={18}
// 										height={18}
// 									/></td>
// 								{/*<td>{row.provider || "—"}</td>*/}
// 								{/*<td>{row.unit || "—"}</td>*/}
// 								{/*<td>{row.quantity || "—"}</td>*/}
// 								{/*<td>{row.unitWeight || "—"}</td>*/}
// 								{/*<td>{row.comment || "—"}</td>*/}
// 								{/*<td>*/}
// 								{/*	{row.objectInfluence || "—"}*/}
// 								{/*	*/}
// 								{/*</td>*/}
// 							</tr>
// 						))}
// 					</tbody>
// 				</table>
// 			)}
// 		{/*</div>*/}
// 		</>
// 	);
// };

export default ManagementSoftware;
